import { useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetAllSeries } from "@/shared/actions/erp/productofactorserie.actions";
import { GeneralTable } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Grid } from "@mui/material";
import { useTableColumnsReporteStock } from "../hook/useTableColumnsReporteStock";
import { useSeriesReporteStock } from "../hook/useSeriesReporteStock.store";
import { useEffect } from "react";


export default function ScrollDialogSeriesReporteInventario() {

  ///* hook
  const {
    columnsSeriesReporteInventario
  } = useTableColumnsReporteStock();

  const isOpenModal = useSeriesReporteStock(s => s.isOpenModal)
  const params = useSeriesReporteStock(s => s.params)
  const producto = useSeriesReporteStock(s => s.producto)
  const cleanSeries = useSeriesReporteStock(s => s.cleanSeries)

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    columnFilters,
    setColumnFilters,
    filterObject,
    setFilterObject
  } = useTableServerSideFiltering()

  ///* query

  const {
    data: dataSeries,
    isLoading: isLoadingSeries,
    isRefetching: isRefetchingSeries
  } = useFetchGetAllSeries({
    params: {
      ...params,
      ...filterObject,
      page: pageIndex + 1,
      page_size: pageSize,
    },
    enabled: true
  })

  useEffect(() => {

    return () => {
      //cleanSeries()
      console.log('destruir componente scroll');
    }
  }, [producto?.id_producto])


  return <ScrollableDialogProps
    open={isOpenModal}
    title={`SERIES #${producto?.codigo} ${producto?.usa_metros ? '(METROS)' : ''}`}
    onCloseIcon={() => {
      setFilterObject({})
      setPagination({
        pageIndex: 0,
        pageSize: 10
      })
      cleanSeries()
    }}
    minWidth="50%"
    contentNode={
      <Grid item>
        <GeneralTable
          columns={columnsSeriesReporteInventario}
          data={dataSeries?.data?.data ?? []}
          isLoading={isLoadingSeries}
          isRefetching={isRefetchingSeries}
          rowCount={dataSeries?.data?.count ?? 0}
          pagination={pagination}
          onPaging={setPagination}
          enableGlobalFilter={false}
          //
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          //
          canEdit={false}
          enableEditing={false}
        />
      </Grid>
    }
  />
}